import React from "react";
import { Link } from "react-router-dom";
export default class ProductDetail extends React.Component 
{
    render()
     {
        return <div>
            {/* Product Detail */}
	<section className="sec-product-detail bg0 p-t-65 p-b-60">
		<div className="container">
			<div className="row">
				<div className="col-md-6 col-lg-7 p-b-30">
					<div className="p-l-25 p-r-30 p-lr-0-lg">
						<div className="wrap-slick3 flex-sb flex-w">
							<div className="wrap-slick3-dots"></div>
							<div className="wrap-slick3-arrows flex-sb-m flex-w"></div>

							<div className="slick3 gallery-lb">
								<div className="item-slick3" data-thumb="images/product-detail-01.jpg">
									<div className="wrap-pic-w pos-relative">
										<img src="images/product-05.jpg" alt="IMG-PRODUCT"/>

										<Link className="flex-c-m size-108 how-pos1 bor0 fs-16 cl10 bg0 hov-btn3 trans-04" to="images/product-detail-01.jpg">
											<i className="fa fa-expand"></i>
										</Link>
									</div>
								</div>

								

							
							</div>
						</div>
					</div>
				</div>
					
				<div className="col-md-6 col-lg-5 p-b-30">
					<div className="p-r-50 p-t-5 p-lr-0-lg">
						<h4 className="mtext-105 cl2 js-name-detail p-b-14">
						Premium Home Deep Cleaning
						</h4>

						<span className="mtext-106 cl2">
						₹1000.79
						</span>

						<p className="stext-102 cl3 p-t-23">
						People: 2-4 | Duration: 4-6 hours (depending on size of the house)
						Full deep cleaning of Rooms and kitchen, including inside trolleys/shelves
						</p>
						<h4></h4>
						{/*  */}
						<div className="p-t-33">
							<div className="flex-w flex-r-m p-b-10">
								<div className="size-203 flex-c-m respon6">
									DATE
								</div>

								<div className="size-204 respon6-next">
									<div className="rs1-select2 bor8 bg0">
									<input type="date" placeholder="DATE"/>
										<div className="dropDownSelect2"></div>
									</div>
								</div>
							</div>

							<div className="flex-w flex-r-m p-b-10">
								<div className="size-203 flex-c-m respon6">
									TIME
								</div>

								<div className="size-204 respon6-next">
									<div className="rs1-select2 bor8 bg0">
									<input type="time" placeholder="TIME"/>
										<div className="dropDownSelect2"></div>
									</div>
								</div>
							</div>

							<div className="flex-w flex-r-m p-b-10">
								<div className="size-204 flex-w flex-m respon6-next">
									<div className="wrap-num-product flex-w m-r-20 m-tb-10">
										<div className="btn-num-product-down cl8 hov-btn3 trans-04 flex-c-m">
											<i className="fs-16 zmdi zmdi-minus"></i>
										</div>

										<input className="mtext-104 cl3 txt-center num-product" type="number" name="num-product" value="1"/>

										<div className="btn-num-product-up cl8 hov-btn3 trans-04 flex-c-m">
											<i className="fs-16 zmdi zmdi-plus"></i>
										</div>
									</div>

									<button className="flex-c-m stext-101 cl0 size-101 bg1 bor1 hov-btn1 p-lr-15 trans-04 js-addcart-detail">
										Add to cart
									</button>

                                    <Link to="/Cleaning" className="btn btn-primary mt-3 py-2 px-4">Back</Link>
								</div>
							</div>	
						</div>

						{/*  */}
						<div className="flex-w flex-m p-l-100 p-t-40 respon7">
							<div className="flex-m bor9 p-r-10 m-r-11">
								<Link to="#" className="fs-14 cl3 hov-cl1 trans-04 lh-10 p-lr-5 p-tb-2 js-addwish-detail tooltip100" data-tooltip="Add to Wishlist">
									<i className="zmdi zmdi-favorite"></i>
								</Link>
							</div>

							<Link to="#" className="fs-14 cl3 hov-cl1 trans-04 lh-10 p-lr-5 p-tb-2 m-r-8 tooltip100" data-tooltip="Facebook">
								<i className="fa fa-facebook"></i>
							</Link>

							<Link to="#" className="fs-14 cl3 hov-cl1 trans-04 lh-10 p-lr-5 p-tb-2 m-r-8 tooltip100" data-tooltip="Twitter">
								<i className="fa fa-twitter"></i>
							</Link>

							<Link to="#" className="fs-14 cl3 hov-cl1 trans-04 lh-10 p-lr-5 p-tb-2 m-r-8 tooltip100" data-tooltip="Google Plus">
								<i className="fa fa-google-plus"></i>
							</Link>
						</div>
					</div>
				</div>
			</div>

			
		</div>

	
	</section>
   

	{/* Related Products */}
	<section className="sec-relate-product bg0 p-t-45 p-b-105">
		
	</section>
        </div>
     }
}